
/**
 * First we will load all of this project's JavaScript dependencies which
 * It is a great starting point when building robust, powerful web
 * applications using Laravel.
 */

require('./bootstrap');

require("bootstrap4-datetimepicker");
require("datatables.net-bs4");
require("select2");

require('./vue');
require('./dashboard');
require('./register');
require('./maps');
require("./map-scrolling");
require('./misc');
require('./datatables');
require('./off-canvas');
require('./select2');
require("./datetimepicker");


// WEBPACK FOOTER //
// ./resources/assets/js/app.js